import Button from '../../components/display/Button'

const GiftThis = ({ storyId, ...props }) => (
  <Button
    as="a"
    href={`/vouchers/create?story_id=${storyId}`}
    uppercase={false}
    ghost
    {...props}
  >
    <span className="icon icon-gift" />
    Gift this
  </Button>
)

export default GiftThis
